import React from "react";
import { slideShowStyle } from "./slideShowStyle";
import Modal from "../Modal/modal";
import ImageSlider from "../ImageSlider/imageSlider";

const SlideShow = ({
                     open, images, startSlide, closeModal,
                   }) => {
  // const { blockStyle = {} } = styles;
  return (
    <Modal open={open}>
      <div css={slideShowStyle.block}>
        <div css={slideShowStyle.sliderWrapper}>
          <ImageSlider imageData={images} startSlide={startSlide} />
        </div>
        <div css={slideShowStyle.close} onClick={closeModal} role="button">
          <span />
          <span />
        </div>
      </div>
    </Modal>
  );
}

export default React.memo(SlideShow);
